
import Vue from 'vue'
import moment from 'moment'

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
})

Vue.filter('moment2', function (timeStamp, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(Number(timeStamp)).format(pattern)
})

Vue.filter('toNum', function (val) {
    return val?Number(val).toFixed(2):0;
})